// extracted by mini-css-extract-plugin
module.exports = {"input":"FilePicker_input__2G84J"};